export default __webpack_public_path__ + "static/media/spark_21.2a1dcbc1.png";